export enum USMapType {
    GEOGRAPHIC = "Geographic",
    DORLING_ELECTORAL_COLLEGE_SIZE = "Dorling Electoral College Size",
    DORLING_VOTER_IMPACT = "Dorling Voter Impact",
}